export function customerMustSetOwnPin(customer) {
	if (!customer) {
		return false;
	}

	return customer.HasPin === false || customer.SetOwnPassword === false;
}

export function customerHasOwnPin(customer) {
	if (!customer) {
		return false;
	}

	return !!customer.HasPin && customer.SetOwnPassword !== false;
}
